import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function postSession(session_id) {
  const { data } = await api.post("/auth/session", { session_id });
  return data;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function listAnalyses() {
  const { data } = await api.get("/analyses");
  return data;
}

export async function getAnalysis(id) {
  const { data } = await api.get(`/analyses/${id}`);
  return data;
}

export async function deleteAnalysis(id) {
  const { data } = await api.delete(`/analyses/${id}`);
  return data;
}

export async function createAnalysis(formData, onProgress) {
  const { data } = await api.post("/analyses", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded * 100) / evt.total));
    },
  });
  return data;
}

export function videoStreamUrl(analysisId) {
  // Cookies will be sent because the same origin (preview backend) is used via REACT_APP_BACKEND_URL
  return `${API_BASE}/analyses/${analysisId}/video`;
}
